import React,{useEffect} from "react"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "./Home.scss"
import BannerSlider from "../commonComponents/BannerSlider"
import CommonSlider from "../commonComponents/CommonSlider"
import { useLocation } from "react-router-dom";
import _ from "lodash";
import Loader from "../commonComponents/Loader"
import { SendGuiDataEvents } from "../CommonScript";

function Home({ games, banners, view_btn_txt, loading }) {
    let { search } = useLocation();
    const settings = {
        dots: true,
        infinite: true,
        speed: 500
    };
    useEffect(() => {
        let guiDataEvents = {};
        guiDataEvents["page"] = "home";
        guiDataEvents["event"] = "open";
        SendGuiDataEvents(guiDataEvents);
    }, []);
  
    function capatalize(title) {
        return title?.charAt(0)?.toUpperCase() + title?.slice(1);
    }

    return (
        <>
            {
                loading ? <Loader /> :
                    <div className="container m-w">
                        {banners && banners.length ? (
                            <BannerSlider
                                settings={{
                                    ...settings,
                                    arrows: false,
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    swipeToSlide: true
                                }}
                                data={banners} />) : ""}
                         {games &&
                            _.map(games).map((item, index) => (
                                <CommonSlider
                                    settings={{
                                        ...settings,
                                        dots: false,
                                        arrows: false,
                                        slidesToShow: 3,
                                        slidesToScroll: 1,
                                        centerPadding: "10%",
                                        swipeToSlide: true,
                                    }}
                                    title={capatalize(item.title)}
                                    data={item.contents}
                                    key={index}
                                    category={item.title}
                                    view_btn_txt={view_btn_txt}
                                />
                            ))}
                    </div>}
        </>
    )
}

export default Home